module.exports = __webpack_public_path__ + "static/download_windows-e4e733fc46ee0216c5b5f0242d9c4e3a.png";